/**
 * Returns a human readable formatted percent based on a float number between 0 and 1.
 * @param {number} percent the percent to format.
 */
export default function (percent) {
  return `${((100 * percent)).toFixed(2).replace(/[.,]00$/, '')}%`;
}
